import styled from 'styled-components';
import { fontTitle, fontBody } from 'Styles/fonts';

import TextInput from '../TextInput/TextInput';
import ButtonOriginal from '../Button/Button';

export const Title = styled.div`
  ${fontTitle(16)};
  margin-bottom: 4px;
`;

export const Subtitle = styled.div`
  ${fontBody(14)};
`;

export const TitleCase = styled.span`
  text-transform: capitalize;
`;

export const Uppercase = styled.span`
  text-transform: uppercase;
`;

export const ImageContainer = styled.div`
  width: 250px;
  margin: 16px auto;
`;

export const Blurb = styled.div`
  ${fontBody(16)};
`;

export const Email = styled(TextInput)`
  margin-top: 16px;
`;

export const Button = styled(ButtonOriginal)`
  margin-top: 16px;
`;
